export type ResourceCalendarDayGridTranslation = {
  dateFormat: string;
  dayEnd: string;
  elementColumn: string;
  free: string;
  fullDay: string;
  gridAriaLabel: string;
  hoursAxis: string;
  phase: {
    assembly: string;
    disassembly: string;
  };
  processBusinessId: string;
  processOwner: string;
  status: {
    confirmed: string;
    free: string;
    tentative: string;
  };
};

export const resourceCalendarDayGridTranslation: ResourceCalendarDayGridTranslation = {
  dateFormat: 'DD.MM.YYYY',
  dayEnd: '24:00',
  elementColumn: 'Element',
  free: 'Brak rezerwacji',
  fullDay: 'Cały dzień',
  gridAriaLabel: 'Kalendarz dzienny zajętości elementów słownika',
  hoursAxis: 'Oś godzinowa',
  phase: {
    assembly: 'Montaż',
    disassembly: 'Demontaż',
  },
  processBusinessId: 'Identyfikator',
  processOwner: 'Opiekun procesu',
  status: {
    confirmed: 'Rezerwacja potwierdzona',
    free: 'Wolny',
    tentative: 'Rezerwacja wstępna',
  },
};
